export default {
  edit: "api:edit",
  create: "api:create",
  delete: "api:delete",
  view: "api:view",
};
